import { initialState, questReducer } from "@/context/QuestProvider/reducer";
import { createFastContext } from "@biom3/react";

export const { Provider, useStore: useQuest } = createFastContext(
  initialState,
  questReducer,
);

interface QuestProviderProps {
  children: React.ReactNode;
}

export const QuestProvider = ({ children }: QuestProviderProps) => {
  return <Provider>{children}</Provider>;
};
